module.exports = __webpack_public_path__ + "img/x.4332420a.svg";